var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"div"}},[_c('div',{attrs:{"id":"contact"}},[_c('img',{attrs:{"src":require("./images/logo2.png")}}),_c('p',[_vm._v("Copyright©恒臻科技（大连）有限责任公司")]),_c('p',[_c('a',{staticStyle:{"color":"white"},attrs:{"href":"https://beian.miit.gov.cn","target":"blank"}},[_vm._v("许可证号：辽ICP备2021006853号")])])])])
}]

export { render, staticRenderFns }